import { render, staticRenderFns } from "./WeatherChaosFish.vue?vue&type=template&id=23b44b93&scoped=true"
import script from "./WeatherChaosFish.vue?vue&type=script&lang=js"
export * from "./WeatherChaosFish.vue?vue&type=script&lang=js"
import style0 from "./WeatherChaosFish.vue?vue&type=style&index=0&id=23b44b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b44b93",
  null
  
)

export default component.exports